import { Component, Input } from '@angular/core'
import { FormControl } from '@angular/forms'

@Component({
    selector: 'app-control-messages',
    templateUrl: './control-messages.component.html',
    styleUrls: ['./control-messages.component.css'],
})
export class ControlMessagesComponent {

    @Input() control: FormControl

    constructor() {
    }

    get errorMessage() {
        for (let propertyName in this.control.errors) {
            if (
                this.control.errors.hasOwnProperty(propertyName) &&
                this.control.touched
            ) {
                return this.getValidatorErrorMessage(
                    propertyName,
                    this.control.errors[propertyName],
                )
            }
        }

        return null
    }

    getValidatorErrorMessage(validatorName: string, validatorValue?: any) {
        let config = {
            required: 'Required',
            invalidCreditCard: 'Is invalid credit card number',
            invalidEmailAddress: 'Invalid email address',
            invalidPassword:
                'Invalid password. Password must be at least 6 characters long, and contain a number.',
            minlength: `Minimum length ${ validatorValue.requiredLength }`,
            maxlength: `Maximum length ${ validatorValue.requiredLength }`,
        }

        return config[validatorName]
    }

}



// WEBPACK FOOTER //
// ./src/app/commons/control-messages/control-messages.component.ts